<div class="flex items-center justify-between mb-6">
  <h1 class="text-2xl font-bold">Consulta de ofertas</h1>
  <p-button
    label="Nueva oferta"
    icon="pi pi-plus"
    (onClick)="nuevaOferta()"
    styleClass="rounded-lg"
    type="button"
  />
</div>

<div class="bg-white rounded-xl shadow p-6 mb-6">
  <h2 class="text-lg font-medium mb-4">Filtros</h2>

  <div class="grid grid-cols-1 md:grid-cols-5 gap-4">
    <p-calendar [(ngModel)]="fechaDesde" placeholder="Desde" dateFormat="dd/mm/yy" showIcon/>
    <p-calendar [(ngModel)]="fechaHasta" placeholder="Hasta" dateFormat="dd/mm/yy" showIcon/>
    <p-floatlabel variant="on">
      <input pInputText id="cups" [(ngModel)]="cups"/>
      <label for="cups">CUPS</label>
    </p-floatlabel>
    <p-dropdown [options]="tarifas" [(ngModel)]="tarifa" placeholder="Tarifa"/>
    <p-dropdown [options]="estados" [(ngModel)]="estado" placeholder="Estado"/>
  </div>

  <div class="mt-4 flex justify-end gap-2">
    <p-button label="Limpiar" icon="pi pi-times" styleClass="p-button-text" (onClick)="limpiar()"/>
    <p-button label="Buscar" icon="pi pi-search"/>
  </div>
</div>

<div class="bg-white rounded-xl shadow p-4">
  <h2 class="text-lg font-medium mb-4">Resultados</h2>

  @if (!loading()) {
    <p-table
      [value]="ofertas()"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 20, 50]"
      [tableStyle]="{ 'min-width': '900px' }"
      styleClass="shadow-sm rounded-xl overflow-hidden"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords}"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 120px" pSortableColumn="id">
            ID
            <p-sortIcon field="id"/>
          </th>
          <th pSortableColumn="nombreCliente">
            Cliente
            <p-sortIcon field="nombreCliente"/>
          </th>
          <th pSortableColumn="cups">
            CUPS
            <p-sortIcon field="cups"/>
          </th>
          <th pSortableColumn="companiaActual">
            Compañía
            <p-sortIcon field="companiaActual"/>
          </th>
          <th pSortableColumn="tipoTarifa">
            Tarifa
            <p-sortIcon field="tipoTarifa"/>
          </th>
          <th pSortableColumn="createdAt" style="width: 160px">
            Creada
            <p-sortIcon field="createdAt"/>
          </th>
          <th style="width: 160px" class="text-right">Acciones</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr (dblclick)="verDetalle(row)" class="cursor-pointer hover:bg-slate-50">
          <td class="font-medium">#{{ row.id }}</td>
          <td>{{ row.nombreCliente || '—' }}</td>
          <td>{{ row.cups || '—' }}</td>
          <td>{{ row.companiaActual || '—' }}</td>
          <td><span class="px-2 py-1 rounded bg-slate-100">{{ row.tipoTarifa }}</span></td>
          <td>{{ row.createdAt | date : 'shortDate' }}</td>
          <td class="text-right">
            <p-button
              icon="pi pi-eye"
              (onClick)="verDetalle(row)"
              styleClass="p-button-text mr-1"
            />
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center py-6 text-slate-500">No hay resultados</td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <div class="space-y-3">
      <p-skeleton height="44px" borderRadius="12px"/>
      <p-skeleton height="44px" borderRadius="12px"/>
      <p-skeleton height="44px" borderRadius="12px"/>
    </div>
  }
</div>
